
import BonusInfluencer from "../../components/BonusInfluencer/Index";
import NavSettings from "../../components/common/NavSettings";

const BonusInfluencerPage = () => {
  // Example bonuses data - replace with actual data from your API
  return (
    <>
      <NavSettings title="Bonos Influencer" route="Inicio" active="Bonos Influencer"/>
    

      <BonusInfluencer />
    </>
  );
};

export default BonusInfluencerPage;
